import { createFeature, createReducer, on } from '@ngrx/store';
import { ConnectivityActions } from './connectivity.actions';
import { AuthActions } from '../auth/auth.action-types';

export interface ConnectivityState {
  isInactive: boolean;
  inactivityTime: number;
}

const initialState: ConnectivityState = {
  isInactive: false,
  inactivityTime: 0,
};

export const connectivityStateReducer = createReducer(
  initialState,
  on(ConnectivityActions.resetToInitialState, () => ({ ...initialState })),
  on(ConnectivityActions.setIsInactive, (state, { isInactive }) => ({
    ...state,
    isInactive,
  })),
  on(ConnectivityActions.setInactivityTime, (state, { inactivityTime }) => ({
    ...state,
    inactivityTime,
  })),
  on(AuthActions.logout, () => ({ ...initialState })),
);

export const connectivityFeature = createFeature({
  name: 'connectivity',
  reducer: connectivityStateReducer,
});
